import script from "./MatchingGameSetup.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchingGameSetup.vue?vue&type=script&setup=true&lang=ts"

import "./MatchingGameSetup.vue?vue&type=style&index=0&id=1127b0c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1127b0c2"]])

export default __exports__